export enum SegmentType {
  WAREHOUSE = "Warehouse",
  AIRPORT = "Airport",
  ROAD = "Road",
  AIR = "Air"
}

export const SegmentTypeOptions = Object.keys(SegmentType).map(key => {
  return { value: key, label: SegmentType[key]}
})
